export default __webpack_public_path__ + "static/media/773.cee9a425.gif";